(function () {

    let filter = []

    let currentUrl = new URL(window.location.href)
    let source = currentUrl.searchParams.get("source") || null;
    if (source) {
        source = source.replaceAll('_','')
        filter = source.split(' ')
    }

    console.log(filter)

    /**
     * Фильтрует карточки
     */
    function filterCards(filter) {
        if (filter.length) {
            document.querySelectorAll('.tile-source:not(.tile-filtered)').forEach(function (element) {
                element.classList.add('tile-filtered');
            });
            filter.forEach(function (item) {
                document.querySelectorAll('.tile-' + item).forEach(function (element) {
                    element.classList.remove('tile-filtered');
                });
            });
        } else {
            document.querySelectorAll('.tile-source').forEach(function (element) {
                element.classList.remove('tile-filtered');
            });
        }
        document.querySelectorAll('#races .articles-tiles').forEach(function (element) {
            if (element.querySelectorAll('.tile-filtered').length === element.querySelectorAll('.tile-source').length) {
                element.classList.add('hidden');
            } else {
                element.classList.remove('hidden');
            }
        });

        let url = '/race/';
        let params = filter.join('+');
        if (params) {
            url += '?source=' + params
        }
        setCurrentPageUrl(url)
    }

    document.addEventListener('DOMContentLoaded', () => {

        filterCards(filter);

        document.querySelectorAll('.menu-filter-item').forEach(function (menuItem) {

            let filterValue = menuItem.getAttribute('data-filter')

            menuItem.addEventListener('click', function (event) {
                event.preventDefault();
                if (menuItem.getAttribute('data-filter') === 'all') {
                    filter = [];
                    document.querySelectorAll('.menu-filter-item.active').forEach(function (item) {
                        item.classList.remove('active')
                    })
                } else {
                    if (menuItem.classList.contains('active')) {
                        menuItem.classList.remove('active')
                        filter = removeItemAll(filter, filterValue)
                    } else {
                        menuItem.classList.add('active')
                        filter.push(filterValue)
                    }

                }
                //localStorage.setItem('race_filter', JSON.stringify(filter.filter(onlyUnique)));

                filterCards(filter);
            })

        })

        filter.forEach(function (filterItem) {
            document.querySelectorAll('[data-filter="' + filterItem + '"]').forEach(function (menuItem) {
                menuItem.classList.add('active');
            });
        });

    })

})()